<div class="plans-page">

  <p-toast position="top-right" />
  <p-confirmDialog />

  <!-- En-tête ─────────────────────────────────────────────────────────────── -->
  <div class="page-top">
    <div class="page-top-left">
      <h1 class="page-title">Plans &amp; Tarifs</h1>
      <p class="page-subtitle">Gérez les offres d'abonnement de la plateforme</p>
    </div>
    @if (authService.hasPermission('PLANS_CREATE')) {
      <a pButton routerLink="/plans/new" icon="pi pi-plus" label="Nouveau plan" class="btn-new"></a>
    }
  </div>

  @if (loading()) {
    <div class="loading-wrap"><p-progressSpinner strokeWidth="4" styleClass="spinner-sm" /></div>
  } @else if (plans().length === 0) {

    <!-- État vide ─────────────────────────────────────────────────────────── -->
    <app-empty-state size="lg" icon="pi-crown" title="Aucun plan configuré"
                      message="Créez votre premier plan tarifaire pour commencer.">
      @if (authService.hasPermission('PLANS_CREATE')) {
        <a emptyStateAction pButton routerLink="/plans/new" icon="pi pi-plus" label="Créer un plan" class="btn-new"></a>
      }
    </app-empty-state>

  } @else {

    <!-- Résumé ───────────────────────────────────────────────────────────── -->
    <div class="summary-bar">
      <span class="summary-item">
        <i class="pi pi-th-large"></i>
        {{ plans().length }} plan{{ plans().length > 1 ? 's' : '' }} au total
      </span>
      @if (featuredPlan()) {
        <span class="summary-item summary-featured">
          <i class="pi pi-star-fill"></i>
          Plan populaire : <strong>{{ featuredPlan()!.name }}</strong>
        </span>
      }
    </div>

    <!-- Grille de cards ──────────────────────────────────────────────────── -->
    <div class="plans-grid">
      @for (plan of plans(); track plan.id) {
        <div class="plan-card" [class.plan-card--featured]="plan.featured">

          @if (plan.featured) {
            <div class="featured-badge"><i class="pi pi-star-fill"></i>Populaire</div>
          }

          <!-- En-tête card -->
          <div class="card-header" [class.card-header--featured]="plan.featured">
            <div class="plan-code">{{ plan.code }}</div>
            <h2 class="plan-name">{{ plan.name }}</h2>
            <div class="plan-price">
              @if (plan.priceMonthly === 0) {
                <span class="price-amount">{{ plan.priceMonthly | fcfa:'Gratuit' }}</span>
              } @else {
                <span class="price-amount">{{ plan.priceMonthly | fcfa }}</span>
                <span class="price-period">/ mois</span>
              }
            </div>
          </div>

          <!-- Limites -->
          <div class="plan-limits">
            <div class="limit-item">
              <i class="pi pi-building"></i>
              <span>{{ formatProps(plan.maxProperties) }} bien{{ plan.maxProperties !== 1 ? 's' : '' }}</span>
            </div>
            <div class="limit-item">
              <i class="pi pi-image"></i>
              <span>{{ formatProps(plan.maxPhotos) }} photo{{ plan.maxPhotos !== 1 ? 's' : '' }} / bien</span>
            </div>
            <div class="limit-item">
              <i class="pi pi-video"></i>
              <span>{{ formatProps(plan.maxVideos) }} vidéo{{ plan.maxVideos !== 1 ? 's' : '' }} / bien</span>
            </div>
            <div class="limit-item">
              <i class="pi pi-calendar"></i>
              <span>Validité {{ plan.validityDays }} jours</span>
            </div>
            <div class="limit-item" [class.limit-item--muted]="!plan.virtualTourEnabled">
              <i [class]="plan.virtualTourEnabled ? 'pi pi-verified' : 'pi pi-ban'"></i>
              <span>
                @if (plan.virtualTourEnabled) {
                  Visite virtuelle ({{ formatProps(plan.maxPanoramas) }} panorama{{ plan.maxPanoramas !== 1 ? 's' : '' }})
                } @else {
                  Visite virtuelle non incluse
                }
              </span>
            </div>
          </div>

          <!-- Fonctionnalités -->
          @if (plan.features.length) {
            <ul class="plan-features">
              @for (feat of plan.features; track $index) {
                <li><i class="pi pi-check-circle"></i><span>{{ feat }}</span></li>
              }
            </ul>
          }

          <!-- Actions -->
          <div class="card-actions">
            @if (authService.hasPermission('PLANS_UPDATE')) {
              <a pButton [outlined]="true" class="btn-edit"
                 [routerLink]="['/plans', plan.id, 'edit']"
                 icon="pi pi-pencil" label="Modifier"></a>
            }
            @if (authService.hasPermission('PLANS_DELETE')) {
              <button pButton [text]="true" severity="danger" class="btn-delete"
                      (click)="confirmDelete(plan, $event)"
                      [disabled]="deleting() === plan.id"
                      [loading]="deleting() === plan.id"
                      icon="pi pi-trash"
                      pTooltip="Supprimer ce plan"></button>
            }
          </div>

        </div>
      }
    </div>

  }
</div>
